import cookies from 'js-cookie'
import store from '@/store'
import request from '@/utils/request'
import {USER_NAME_PREFIX, USER_INFO_PREFIX} from "@/utils/cacheUtil"
import {getLoginUserInfo, updateLoginCompany,	listCurrentUserDept} from "@/api/system/user"

//验证当前是否有登录用户
export async function checkLoginStatus() {
    //验证Cookie中是否有Token值
    let token = cookies.get('token')
    if (!token) {
        return false
    }

    //验证Token是否过期
    await request.get('/getUserInfo').then(res => {
        store.dispatch('updateUseInfo', res.data)
        sessionStorage.setItem(USER_INFO_PREFIX, JSON.stringify(res.data))
    })
}

export function isLogin() {
    let userInfo = sessionStorage.getItem(USER_INFO_PREFIX)
    if (userInfo) userInfo = JSON.parse(userInfo)
    return userInfo.nickName ? true : false
}

/**
 * 获取当前登录用户信息
 * @returns
 */
export async function getUserInfo(isCache = true) {
    //从vux 中获取用户信息
    let userInfo = {}
	//从缓存中提取用户信息
	if(isCache === true) userInfo =store.state.userInfo
	if (Object.keys(userInfo).length > 0) return userInfo
	//后台加载最新用户信息
	let result =  await getLoginUserInfo()
	if (Object.keys(result) <= 0) return userInfo
	//响应结果提取
	userInfo = result
	//更新vux中用户信息
	store.dispatch('updateUseInfo', userInfo)
    return userInfo
}

export async function getUserName(id) {
    if (!id) return ''
    let object = sessionStorage.getItem(USER_NAME_PREFIX + id)
    if (object) {
        return object
    }
    let res = await request.get('/user/getUserName/' + id)
    if (res && res.data) {
        sessionStorage.setItem(USER_NAME_PREFIX + id, res.data)
        return res.data
    }
    return ''
}
export async function getUserData(id) {
    return request({
        url: '/user/getUserData/' + id,
        method: 'GET',
        data: {
            id: id
        }
    })
}

// 用户密码重置
export function updateUserPwd(params) {
    return request({
        url: '/updatePwd',
        method: 'get',
        params: params
    })
}


//更新用户信息
export function updateUserInfo(userInfo) {
    return request({
        url: '/user/update',
        method: 'post',
        data: userInfo
    })
}

// 退出登录
export function loginOut() {
    //清除VUEX中用户信息
    store.dispatch('removeUserInfo')
    //清除Token
    cookies.remove('token')
    //清除
    localStorage.removeItem("ylcache")
}

// 二级密码验证
export function ifSecondary(sPassword, id) {
    return request({
        url: '/user/ifSecondary/' + sPassword + "/" + id,
        method: 'POST',
        data: {
            sPassword: sPassword,
            id: id
        }
    })
}

// 获取用户信息
export function getUser(loginName) {
    return request({
        url: '/user/getUser/' + loginName,
        method: 'GET',
        params: {loginName: loginName}
    })
}


/**
 * 获取当前登录企业主键
 */
export const getCurrentCompany = () => store.state.userCo
/**
 * 获取当前登录企业名称
 */
export const getCurrentCompanyName = () => store.state.userCoName

/**
 * 获取当前登录企业对象
 */
export const getCurrentCompanyObject = ()=> store.state.dept

/**
 * 获取当前用户相关企业列表
 */
export const queryCurrentUserCompany = async () => {
	let result = await listCurrentUserDept()
	if(result.code != 200) return []
	return result.data
}

/**
 * 所登录的企业确认
 * 0:游客模式
 */
export const companyAck = (id, deptName = "游客", dept) => {
	console.log(" companyAck 被触发了  ", id)
	//更新企业主键
	store.commit('updateUserCo', id)
	//更新企业名称
	store.commit('updateUserCoName', deptName)
	//更新企业对象
	store.commit('updateDept',dept)
	//----更新用户信息中企业主键----
	let userInfo = store.state.userInfo
	if(Object.keys(userInfo) <= 0) return
	//赋值当前登录企业编码
	userInfo.deptId = id
	//更新缓存
	store.commit("updateUseInfo", userInfo)
	//将确认结果向后台同步
	updateLoginCompany(id)
}

/**
 * 是否企业管理员
 */
export const isEnterpriseAdmin = async (pollingCount = 0 ) => {

	const  userInfo = await getUserInfo(pollingCount < 1)//用户信息
	const roleList = userInfo.roleList 
	console.log("roleList value:", roleList)
	if(roleList == undefined || roleList.length <= 0){
		if(pollingCount > 1) return false
		return await isEnterpriseAdmin(pollingCount + 1)
	}
	//判断是否包含企业管理员角色
	const result = roleList.some(role => role.code === 'GY20250828' || role.code === 'CG20250828' || role.code === 'sys-admin')
	console.log("result value:", result)
	return result
}

/**
 * 是否业务员
 * @param {Number} pollingCount 轮询次数
 * @returns Boolean 是否
 */
export const isSalesperson = async (pollingCount = 0 ) => {

	const  userInfo = await getUserInfo(pollingCount < 1)//用户信息
	const roleList = userInfo.roleList 
	console.log("roleList value:", roleList)
	if(roleList == undefined || roleList.length <= 0){
		if(pollingCount > 1) return false
		return await isSalesperson(pollingCount + 1)
	}
	//判断是否包含业务员角色
	const result = roleList.some(role => role.code === 'GYS20251204')
	console.log("result value:", result)
	return result
}

/**
 * 是否财务
 * @param {Number} pollingCount 轮询次数
 * @returns Boolean 是否
 */
export const isFinance = async (pollingCount = 0 ) => {

	const  userInfo = await getUserInfo(pollingCount < 1)//用户信息
	const roleList = userInfo.roleList 
	console.log("roleList value:", roleList)
	if(roleList == undefined || roleList.length <= 0){
		if(pollingCount > 1) return false
		return await isFinance(pollingCount + 1)
	}
	//判断是否包含财务员角色
	const result = roleList.some(role => role.code === 'finance_code')
	console.log("result value:", result)
	return result
}